import { SessionAction } from "@/entities/session";
import { setupApiHandlers } from "@/shared/api";
import { routePaths } from "@/shared/config";
import { Dispatch, RefObject, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useSessionApiBinding = (
    dispatch: Dispatch<SessionAction>,
    tokenRef: RefObject<string | null>,
    refreshToken: () => Promise<string | null>
) => {
    const navigate = useNavigate();

    useEffect(() => {
        setupApiHandlers({
            getAccessToken: () => tokenRef.current,
            refreshToken,
            onSessionExpired: () => {
                tokenRef.current = null;
                dispatch({ type: 'LOGOUT' });
            },
            onForbidden: () => navigate(routePaths.errors.accessDenied),
        });
    }, [refreshToken]);
};